import { LegalPage } from '../components/LegalPage';
import { SP_EMAIL } from '../lib/brand';

const SECTIONS = [
  { h: '1. No Accounts, No Personal Details', p: 'Trade PMI is free and requires no account. We do not ask for your name, email address, password or payment details to use the platform.' },
  {
    h: '2. What Is Stored On Your Device',
    list: [
      'Your acknowledgement that the platform provides descriptive data only (so you are not asked again)',
      'A random, pseudonymous session ID and your analytics consent choice',
    ],
  },
  {
    h: '3. Optional Usage Analytics',
    p: 'Only if you opt in, we record pseudonymous events such as page views and which market was analysed. We never record personal details. Raw events are deleted after 30 days; only aggregated counts are kept and shown on the public Usage page.',
  },
  {
    h: '4. Analysis History',
    p: 'Each analysis stores an anonymous snapshot of the engine read for that ticker (not linked to you). This powers Trade DNA and Scenario Match for everyone. When a shared card is opened, we count it once per device per day using a random device ID stored in your browser (hashed on our side and deleted after 90 days).',
  },
  {
    h: '5. Third-Party Services',
    list: ['Yahoo Finance (yfinance): market data', 'AI language model: descriptive summaries of market data', 'MongoDB: database hosting'],
  },
  { h: '6. Contact', p: `For privacy questions, email ${SP_EMAIL}.` },
];

export default function Privacy() {
  return <LegalPage title="Privacy Policy" sections={SECTIONS} testId="privacy-title" />;
}
